var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.3438C6.68627 11.3438 4 14.1769 4 17.6719C4 21.1668 6.68627 24 10 24C13.3137 24 16 21.1668 16 17.6719C16 14.1769 13.3137 11.3438 10 11.3438ZM12.8281 19.6604L11.8854 20.6547L10 18.6661L8.11458 20.6547L7.17187 19.6604L9.05729 17.6719L7.17187 15.6833L8.11458 14.6891L10 16.6776L11.8854 14.6891L12.8281 15.6833L10.9427 17.6719L12.8281 19.6604Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V2.8125H0V0Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.21875V14.1562H3.47631C4.69284 11.6558 7.15764 9.9375 10 9.9375C12.8424 9.9375 15.3071 11.6558 16.5237 14.1562H20V4.21875H0ZM17.3333 9.9375H13.3333V8.53125H17.3333V9.9375Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashError);
export default __webpack_public_path__ + "static/media/cash_error.1673e1198d53ace2adafe36a0e68a1af.svg";
export { ForwardRef as ReactComponent };